import { SEARCH_STRING_MANIFEST_INFO_SETTING_KEY } from '../../constants/microfrontends';
import { useApplicationContext } from '../../containers/ApplicationContext';
import { IManifestInfo } from '../../types/manifestInfo';

export function useSearchStringManifestInfo(): IManifestInfo | null {
  const { config } = useApplicationContext();

  return config.get<IManifestInfo | null>(SEARCH_STRING_MANIFEST_INFO_SETTING_KEY) ?? null;
}
